import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";

import "./utils/i18n";
import { authProvider } from "./utils/auth-provider";

import store from "./store/store";

import AppContainer from "./components/App/AppContainer";

document.title = `${process.env.REACT_APP_ENV_NAME} Control App`;

const router = createBrowserRouter([
    {
        path: "*",
        element: <AppContainer />,
    },
]);

const Index: React.FC = () => <RouterProvider router={router} />;

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
    <Provider store={store}>
        <MsalProvider instance={authProvider}>
            <Index />
        </MsalProvider>
    </Provider>
);
